import React from 'react';
import FieldLabelsList from './FieldLabelsList';

function AvailableMeasures() {
  return (
    <FieldLabelsList
      fieldType="measure"
      paneTitleId="ui-reports.settings.sections.dataModels.pages.availableMeasures.lable"
      nameColumnId="ui-reports.sections.dataModels.availableMeasures.columns.name"
      paneId="available-measures-settings-pane"
      listId="available-measures-list"
      showCubeSelect
      getItems={(response, cubeName) => {
        const cube = response?.cubes?.find(c => c.name === cubeName);
        return cube?.measures || [];
      }}
    />
  );
}

export default AvailableMeasures;
